import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import StoreUtil from "../store.util.js";

const state = {
  ticketList: StoreUtil.state(),
  populatedBoards: StoreUtil.state(),
};

const inventoryModule = {
  state,
  mutations,
  actions,
  getters,
};

export default inventoryModule;
